import React from 'react';
import { XIcon, AlertTriangleIcon } from 'lucide-react';
interface DeleteLessonModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  lessonTitle: string;
  studentName?: string;
  darkMode?: boolean;
}
export const DeleteLessonModal: React.FC<DeleteLessonModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  lessonTitle,
  studentName,
  darkMode = true
}) => {
  if (!isOpen) return null;
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" data-id="element-1287">
      <div className={`relative w-full max-w-md rounded-xl shadow-2xl ${darkMode ? 'bg-navy-800 text-white' : 'bg-white text-gray-900'}`} data-id="element-1288">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-700" data-id="element-1289">
          <div className="flex items-center gap-3" data-id="element-1290">
            <div className="p-2 bg-red-500/10 rounded-lg" data-id="element-1291">
              <AlertTriangleIcon className="h-6 w-6 text-red-500" data-id="element-1292" />
            </div>
            <h2 className="text-xl font-semibold" data-id="element-1293">Delete Lesson</h2>
          </div>
          <button onClick={onClose} className="p-2 rounded-lg hover:bg-gray-700/50 transition-colors" data-id="element-1294">
            <XIcon className="h-5 w-5" data-id="element-1295" />
          </button>
        </div>
        {/* Content */}
        <div className="p-6 space-y-4" data-id="element-1296">
          <p className={darkMode ? 'text-gray-300' : 'text-gray-600'} data-id="element-1297">
            Are you sure you want to delete this lesson?
          </p>
          <div className={`p-4 rounded-lg ${darkMode ? 'bg-navy-900/50' : 'bg-gray-50'}`} data-id="element-1298">
            <p className="font-medium" data-id="element-1299">{lessonTitle}</p>
            {studentName && <p className={`text-sm mt-1 ${darkMode ? 'text-gray-400' : 'text-gray-500'}`} data-id="element-1300">
                Student: {studentName}
              </p>}
          </div>
          <p className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-500'}`} data-id="element-1301">
            This action cannot be undone.
          </p>
        </div>
        {/* Footer */}
        <div className="flex gap-3 p-6 border-t border-gray-700" data-id="element-1302">
          <button onClick={onClose} className={`flex-1 px-4 py-2 rounded-lg font-medium transition-colors ${darkMode ? 'bg-navy-900/50 hover:bg-navy-900 text-white' : 'bg-gray-100 hover:bg-gray-200 text-gray-700'}`} data-id="element-1303">
            Cancel
          </button>
          <button onClick={handleConfirm} className="flex-1 px-4 py-2 bg-red-500 hover:bg-red-600 text-white rounded-lg font-medium transition-colors" data-id="element-1304">
            Delete Lesson
          </button>
        </div>
      </div>
    </div>;
};